import { render, staticRenderFns } from "./BaseInputRequired.vue?vue&type=template&id=283f2785&scoped=true&"
import script from "./BaseInputRequired.vue?vue&type=script&lang=js&"
export * from "./BaseInputRequired.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputRequired.vue?vue&type=style&index=0&id=283f2785&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283f2785",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('283f2785')) {
      api.createRecord('283f2785', component.options)
    } else {
      api.reload('283f2785', component.options)
    }
    module.hot.accept("./BaseInputRequired.vue?vue&type=template&id=283f2785&scoped=true&", function () {
      api.rerender('283f2785', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseInputRequired.vue"
export default component.exports